<template>
  <div>
    <el-drawer
      :visible="Visible"
      size="70%"
      :title="this.descripcion"
      @close="$emit('VisibleFalse', false)"
    >
      <div class="contenedor-Grafico">
        <IEcharts
          class="grafico"
          :option="bar"
          :loading="loading1"
          style="
            width: 900px;
            height: 400px;
            border-radius: 14px;
            margin-top: 4px;
            position: relative;

            background-color: #f3f7fa;
          "
        />
      </div>
      <el-card class="box-card">
        <div class="table-container">
          <el-table
            class="Tabla"
            :data="tableData"
            style="width: 80%"
            v-loading="Loading"
          >
            <el-table-column prop="fecha" label="Fecha" width="180">
            </el-table-column>
            <el-table-column prop="tarjeta" label="TarjetaId" width="130">
            </el-table-column>
            <el-table-column prop="nombreEmpresa" label="Empresa" width="180">
            </el-table-column>
            <el-table-column prop="nombreCliente" label="Cliente" width="180">
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage2"
            :page-sizes="[6, 200, 300, 400]"
            :page-size="6"
            layout="sizes, prev, pager, next"
            :total="registrosTotal"
          >
          </el-pagination>
        </div>
      </el-card>
    </el-drawer>
  </div>
</template>

<script>
import IEcharts from "vue-echarts-v3/src/full.js";
export default {
  components: {
    IEcharts
  },

  watch: {
    Visible(val) {
      if (val) {
        console.log(this.descripcion);
        this.paginaActual = 1;
        this.currentPage2 = 1;
        this.GetData();
        //this.GetDataForGraph();
      }
    }
  },

  props: {
    mes: Number,
    year: Number,
    proveedor: Number,
    cliente: Number,
    descripcion: String,
    Visible: {
      Boolean,
      default: false
    }
  },
  data() {
    return {
      loading1: false,
      tableData: [],
      tableData2: [],
      rnc_empresa: String,
      rnc_cliente: String,
      //descripcion:String,
      Isvisible: false,
      isLoading: false,
      Loading: false,
      checked: true,
      Chehcked: [],
      dia: String,
      ncf: String,
      totalDeRegistrosPorPagina: 6,
      paginaActual: 1,
      currentPage2: 1,
      registrosTotal: 0,
      bar: {
        title: {
          text: ""
        },
        tooltip: {},
        xAxis: {
          data: []
        },
        yAxis: {},
        series: [
          {
            name: "Cantidad de Transacciones",
            type: "line",
            data: []
          },
          {
            name: "",
            type: "line",
            data: []
          }
        ]
      }
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.paginaActual = val;
      this.GetData();
      this.currentPage2 = this.paginaActual;
    },
    handleSizeChange(val) {
      this.totalDeRegistrosPorPagina = val;
      this.GetData();
    },

    /*async GetDataForGraph() {
      this.bar.xAxis.data = [];
      this.bar.series[0].data = [];
      this.loading1 = true;

      await this.$http
        .get(
          `/api/tennos/GetDataForGraphStates?year=${this.year}&month=${this.mes}&EmpresaId=${this.proveedor}&ClientId=${this.cliente}&descripcion=${this.descripcion}`
        )
        .then((resp) => {
          resp.data.forEach((element) => {
            this.bar.xAxis.data.push(element.Dia);
            this.bar.series[0].data.push(element.Cantidad);
          });
        });

      this.loading1 = false;
    },*/
    async GetData() {
      this.tableData = [];
      this.Loading = true;
      this.bar.xAxis.data = [];
      this.bar.series[0].data = [];
      this.loading1 = true;

      await this.$http
        .get(
          `/api/tennos/GetDetailForAuditRecargas?year=${this.year}&month=${this.mes}&Page=${this.paginaActual}&recordsPerPage=${this.totalDeRegistrosPorPagina}&EmpresaId=${this.proveedor}&ClientId=${this.cliente}&descripcion=${this.descripcion}`
        )
        .then((resp) => {
          this.registrosTotal = 0;
          console.log(resp);
          resp.data.datagrafica.forEach((element) => {
            this.bar.xAxis.data.push(element.Dia);
            this.bar.series[0].data.push(element.Cantidad);
            this.registrosTotal += element.Cantidad;
          });
          // this.registrosTotal = resp.data.total;

          resp.data.listadoFiltradoPaginado.forEach((element) => {
            console.log(element);
            this.tableData.push(element);
          });
          this.Loading = false;
          this.loading1 = false;
        });
    }
  }
};
</script>

<style scoped>
.Table {
  margin: 0 auto;
  padding-left: 200px;
}
.Tabla {
  margin: 0 auto;
  /* padding-left: 200px; */
}
.grafico {
  margin: 0 auto;
}
.contenedor-Grafico {
  width: 950px;
  height: 380px;
  margin-top: 40px;
  margin-bottom: 25px;
  margin-left: auto;
  margin-right: auto;
  /* margin: 10 auto; */
}
.table-container {
  margin: 0 auto;
}
.pagination {
  /* margin:0 auto; */
  margin-left: 116.283px;
}
.box-card {
  padding: 10px;
  margin-top: 3rem;
  margin-left: 90px;
  margin-right: 90px;
}
</style>
